import { Box, CircularProgress } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";

const Loading = () => {
  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "white",
            zIndex: 9999,
          }}
        >
          <CircularProgress color="rgb(199, 170, 126)" />
        </Box>
      </motion.div>
    </AnimatePresence>
  );
};

export default Loading; 
